import {Component, Input, OnInit} from '@angular/core';
import {Subject} from 'rxjs/Subject';

import {DomSanitizer} from '@angular/platform-browser';

/* tslint:disable:no-unused-variable */
import {Observable} from 'rxjs/Observable';
/* tslint:enable:no-unused-variable */

declare var window: any;


@Component({
	selector: 'itd-dialog',
	providers: [],
	templateUrl: './dialog.component.html',
	styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
	constructor(
		private sanitizer: DomSanitizer
	) {}


	@Input() title = '';
	@Input() content1 = '';
	@Input() content2 = '';
	@Input() ok = '';
	@Input() cancel = '';
	@Input() data = '';
	@Input() helpUrlLabel = '';
	@Input() helpUrlString = '';

	okButton: any;

	private dialogCompleteSource = new Subject<any>();

	private dialogComplete = this.dialogCompleteSource.asObservable();


	ngOnInit() {
	}


	showDialog() {
		let modal = document.getElementById('myModal');
		modal.style.display = 'block';

		this.okButton = document.getElementById('okButton');
		setTimeout(() => {
			let cancelButton = document.getElementById('cancelButton');
			if (this.cancel.length === 0) {
				cancelButton.style.display = 'none';
			} else {
				cancelButton.style.display = 'block';
			}

			this.okButton.focus();
		}, 100);

		return this.dialogComplete;
	}


	onCancel() {
		let modal = document.getElementById('myModal');
		modal.style.display = 'none';
		let complete = {
			confirm: false,
			data: this.data
		};
		this.dialogCompleteSource.next(complete);
	}


	onOk() {
		let modal = document.getElementById('myModal');
		modal.style.display = 'none';
		let complete = {
			confirm: true,
			data: this.data
		};
		this.dialogCompleteSource.next(complete);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/dialog/dialog.component.ts